<template>
  <div id="_side_menu">
    <img src="../../public/assets/images/logo-text.png" alt="homepage" class="dark-logo" width="240px"/>
    <div ref="profileDropdownRef" class="profile-text dropdown">
      <a href="#" id="profile-name" class="pl-2 dropdown-toggle u-dropdown" role="button"
         aria-haspopup="true"
         :aria-expanded="menuOpen"
         @click.prevent="toggleUserMenu">
        {{ profile.display_name }}
      </a>
      <div class="dropdown-menu animated flipInY" :class="{ show: menuOpen }">
        <!--
        <a href="#" class="dropdown-item"><i class="ti-user"></i> My Profile</a> <a href="#" class="dropdown-item"><i
        class="ti-wallet"></i> My Balance</a> <a href="#" class="dropdown-item"><i class="ti-email"></i> Inbox</a>
        <div class="dropdown-divider"></div>
        <a href="#" class="dropdown-item"><i class="ti-settings"></i> Account Setting</a>
        <div class="dropdown-divider"></div>
        -->
        <a href="login.html" class="dropdown-item" @click.prevent="logout">
          <i class="fa fa-power-off"></i>ログアウト
        </a>
      </div>
    </div>
    <nav class="sidebar-nav">
      <ul>
        <li>
          <div class="link" @click="naviMaintenance">
            <i class="fa fa-info-circle"></i>
            <span>メンテナンス情報</span>
          </div>
          <div class="link" v-if="!isFree" @click="naviTsb">
            <i class="fa fa-question-circle"></i>
            <span>よくあるご質問</span>
          </div>
          <div class="link" v-if="isFree" @click="naviTss">
            <i class="fa fa-question-circle"></i>
            <span>よくあるご質問</span>
          </div>
          <div class="link" @click="naviManual">
            <i class="fa fa-book"></i>
            <span>マニュアル</span>
          </div>
        </li>
        <li>
          <i class="fa fa-clock"></i>
          <span>日々の業務 </span>
          <ul>
            <li>
              <router-link to="/plan" v-if="!isFree">ケアプラン</router-link>
            </li>
            <li>
              <router-link to="/shift/staff" v-if="!isFree">シフト表(スタッフ別)</router-link>
            </li>
            <li>
              <router-link to="/shift/staff2" v-if="!isFree">シフト表(シフト)</router-link>
            </li>
            <li>
              <router-link to="/import/kaigo-no-mori/schedule" v-if="isKaigoNoMori">ケアプラン(介護の森)</router-link>
            </li>
            <li>
              <router-link to="/report">報告・承認</router-link>
            </li>
          </ul>
        </li>
        <li>
          <i class="fa fa-cog"></i>
          <span>データ管理</span>
          <ul>
            <li>
              <router-link to="/office">事業所管理</router-link>
            </li>
            <li>
              <router-link to="/staff">スタッフ管理</router-link>
            </li>
            <li>
              <router-link to="/import/kaigo-no-mori/staff" v-if="isKaigoNoMori">スタッフ(介護の森-職員)</router-link>
            </li>
            <li>
              <router-link to="/import/kaigo-no-mori/manager" v-if="isKaigoNoMori">スタッフ(介護の森-ケアマネ)</router-link>
            </li>
            <li>
              <router-link to="/user">利用者管理</router-link>
            </li>
            <li>
              <router-link to="/instruction">申し送り管理</router-link>
            </li>
            <li>
              <router-link to="/import/f1user" v-if="isF1">利用者(ケアマネっ子)</router-link>
            </li>
            <li>
              <router-link to="/import/kaigo-no-mori/user" v-if="isKaigoNoMori">利用者(介護の森)</router-link>
            </li>
            <li v-if="isSakura">
              <router-link to="/code">固有コード管理</router-link>
            </li>
            <li v-if="isNativeCode">
              <router-link to="/teresa-standard-code">固有コード管理</router-link>
            </li>
            <li v-if="isFree">
              <router-link to="/custom-service-code">サービスコード管理</router-link>
            </li>
          </ul>
        </li>
        <li v-if="isTeresaStandard">
          <i class="fa fa-file-text"></i>
          <span>CSVデータ取り込み</span>
          <ul>
            <li>
              <router-link to="/import/teresa-standard/schedule">ケアプラン取り込み</router-link>
            </li>
            <li>
              <router-link to="/import/teresa-standard/staff">スタッフ取り込み</router-link>
            </li>
            <li>
              <router-link to="/import/teresa-standard/user">利用者取り込み</router-link>
            </li>
          </ul>
        </li>
      </ul>
    </nav>
  </div>
</template>

<script setup>
import { ref, computed, onBeforeMount, onMounted, onUnmounted } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import SiteUtils from '../libs/SiteUtils'
import Constants from '@/constants'

const store = useStore()
const router = useRouter()

// Reactive state
const isFree = ref(false)
const isF1 = ref(false)
const isSakura = ref(false)
const isNativeCode = ref(false)
const isKaigoNoMori = ref(false)
const isTeresaStandard = ref(false)
const menuOpen = ref(false)
const profileDropdownRef = ref(null)

// Computed properties
const profile = computed(() => store.state.session.profile)

// Lifecycle hooks
onBeforeMount(() => {
  isFree.value = SiteUtils.isFree()
  isF1.value = (Constants.FunctionMask.F1 & profile.value.site.function_mask) === Constants.FunctionMask.F1
  isSakura.value = (Constants.FunctionMask.SAKURA & profile.value.site.function_mask) === Constants.FunctionMask.SAKURA
  isNativeCode.value = (Constants.FunctionMask.NATIVE_CODE & profile.value.site.function_mask) === Constants.FunctionMask.NATIVE_CODE
  isKaigoNoMori.value = (Constants.FunctionMask.KaigoNoMori & profile.value.site.function_mask) === Constants.FunctionMask.KaigoNoMori
  isTeresaStandard.value = (Constants.FunctionMask.TeresaStandard & profile.value.site.function_mask) === Constants.FunctionMask.TeresaStandard
})

const closeUserMenuOnOutsideClick = (e) => {
  const root = profileDropdownRef.value
  if (root && !root.contains(e.target)) {
    menuOpen.value = false
  }
}

onMounted(() => {
  document.addEventListener('click', closeUserMenuOnOutsideClick)
})

onUnmounted(() => {
  document.removeEventListener('click', closeUserMenuOnOutsideClick)
})

const toggleUserMenu = () => {
  menuOpen.value = !menuOpen.value
}

// Methods
const naviMaintenance = () => {
  window.open('https://www.teressa.jp/Release-Maintenance', 'teressa_maintenance')
}

const naviTsb = () => {
  window.open('https://www.teressa.jp/FAQ/tsb', 'teressa_trouble_shooting_basic')
}

const naviTss = () => {
  window.open('https://www.teressa.jp/FAQ/tss', 'teressa_trouble_shooting_storage')
}

const naviManual = () => {
  window.open('https://www.teressa.jp/manual')
}

const logout = () => {
  menuOpen.value = false
  store.dispatch('session/logoutAsync')
    .catch(error => {
      console.error(error)
    })
    .finally(() => {
      router.push('/login')
    })
}
</script>

<style scoped>
.link {
  cursor: pointer;
}

.dark-logo {
  height: 45px;
  width: 180px;
}

.sidebar-nav {
  color: white;
}

.sidebar-nav a {
  color: white;
  font-size: small;
}

#profile-name {
  color: white;
}

.profile-text.dropdown {
  position: relative;
}
</style>
